import React from 'react';
import type {DoppeViewerSettingControlCustom} from '../../doppe-viewer-setting-control-custom';
import {doppeViewerSettingControlCustom} from '../../doppe-viewer-setting-control-custom';
import {DoppeViewerTextBox} from '../../../doppe-viewer-text-box/doppe-viewer-text-box';
import type {TextBoxTypes, TextBoxInputMode} from '@wix/devzai-utils-react';

export interface TextBoxControlOptions {
    placeholder?: string;
    maxLength?: number | null;
    /** HTML input type (e.g., TextBoxTypes.PhoneNumber for 'tel'). */
    type?: TextBoxTypes;
    /** Mobile keyboard hint (e.g., TextBoxInputMode.Numeric). Overrides the default derived from type. */
    inputMode?: TextBoxInputMode;
    /** Transforms the raw input value, e.g. stripping non-digit characters. Applied before maxLength. */
    inputFilter?: (value: string) => string;
}

/**
 * Creates a custom control for a text box field.
 * Suitable for short text input with optional character filtering.
 */
export function doppeViewerTextBoxControlCreate(
    options: TextBoxControlOptions = {}
): DoppeViewerSettingControlCustom<string> {
    const {placeholder, maxLength, type, inputMode, inputFilter} = options;

    return doppeViewerSettingControlCustom<string>({
        render: (props) => {
            const {value, onValueChange, hasError, onBlur} = props;

            const handleChange = (newValue: string) => {
                const filtered = inputFilter ? inputFilter(newValue) : newValue;
                const processed = maxLength !== undefined && maxLength !== null && filtered.length > maxLength
                    ? filtered.substring(0, maxLength)
                    : filtered;
                onValueChange(processed);
            };

            return (
                <DoppeViewerTextBox
                    value={value ?? ''}
                    onTextChange={handleChange}
                    placeholder={placeholder}
                    hasError={hasError}
                    onBlur={onBlur}
                    type={type}
                    inputMode={inputMode}
                />
            );
        },
    });
}
